import { useCustomSelector } from '@core/js/store/hooks';
import { POPUPS_REDUCER } from '@core/js/store/constants';

export const useIsPopupManager = () => {
    const { popups } = useCustomSelector(POPUPS_REDUCER);

    return Object.keys(popups).length;
};
